import keycloakApi from './keycloak-auth';

export interface PaymentMethodBreakdown {
  method: string;
  count: number;
  totalAmountCents: number;
}

export interface TopSupplier {
  id: string;
  displayName: string;
  paymentCount: number;
  totalAmountCents: number;
}

export interface SupplierStatusSummary {
  verified: number;
  unverified: number;
  pendingValidation: number;
  pendingEnrollment: number;
}

export interface RecentPaymentFile {
  id: string;
  fileName: string;
  status: string;
  createdAt: string;
  paymentCount: number;
  totalAmountCents: number;
}

export interface RecentPayment {
  id: string;
  payeeName: string;
  amountCents: number;
  status: string;
  executionDate: string | null;
  createdAt: string;
}

export interface ClientStatsData {
  clientPartyId: string;
  clientName: string;
  // Today's stats
  paymentFilesProcessedToday: number;
  paymentsProcessedToday: number;
  paymentTotalTodayCents: number;
  // Month-to-date stats
  paymentFilesProcessedMTD: number;
  paymentsProcessedMTD: number;
  paymentTotalMTDCents: number;
  // Year-to-date stats (rolling 12 months)
  paymentFilesProcessedYTD: number;
  paymentsProcessedYTD: number;
  paymentTotalYTDCents: number;
  // All-time stats
  totalPaymentsAllTime: number;
  totalPaymentFilesAllTime: number;
  totalVolumeAllTimeCents: number;
  // Breakdowns
  paymentMethodBreakdown: PaymentMethodBreakdown[];
  topSuppliers: TopSupplier[];
  totalSuppliers: number;
  supplierStatusSummary: SupplierStatusSummary;
  // Recent activity
  recentPaymentFiles: RecentPaymentFile[];
  recentPayments: RecentPayment[];
  generatedAt: string;
}

/**
 * Fetch statistics for a specific client.
 * This endpoint is protected and only accessible to internal/admin users.
 */
export const getClientStats = async (clientPartyId: string): Promise<ClientStatsData | null> => {
  return keycloakApi.authenticatedApiCall<ClientStatsData>(
    `/client/stats-email/preview/${clientPartyId}`
  );
};
